<template>
  <div class="s-setting-container no-border">
    <div v-if="loadingPlans" class="loading-container">
      <img src="@shared/assets/img/general/loading.svg" alt="loading" />
    </div>
    <div class="contacts-container">
      <div class="flex-row just-between mb-5 align-center" style="width: 100%;">
        <div class="flex-column">
          <div class="header">
            Partner Contacts
          </div>
          <div class="sub-header">
            Manage point of contacts for SmartAC.com
          </div>
        </div>
        <div v-if="adminRole === 'admin'">
          <button class="icn-btn" @click="toggleActionModal(true, 'edit-contact', { contactType: 'Business' })">
            <v-icon color="#4979FF" dark medium>
              mdi-plus
            </v-icon>
            Add new
          </button>
        </div>
      </div>
      <div class="cards-wrapper">
        <div v-for="contact in contacts.filter((x) => x.contactType === 'Business')" style="width: fit-content;">
          <PartnerContact :contact="contact" :toggleActionModal="toggleActionModal" />
        </div>
      </div>
      <div class="sac__font-16 n40 mt-5">
        Contacts for specific trade service requests can be managed in <a @click="change('request')">Service Requests</a>. A support contact for general member requests can be set in <a @click="change('info')">Company Information</a>.
      </div>
    </div>
    <!-- <div class="contacts-container">
      <div class="flex-row just-between mb-5 align-center" style="width: 100%;">
        <div class="flex-column">
          <div class="header">Contacts for Members</div>
          <div class="sub-header">Manage contacts visible to members in-app</div>
        </div>

        <div v-if="adminRole === 'admin'">
          <button class="icn-btn" @click="toggleActionModal(true, 'edit-contact', { contactType: 'Support' })">
            <v-icon color="#4979FF" dark medium>
              mdi-plus
            </v-icon>
            Add new
          </button>
        </div>
      </div>
      <div class="cards-wrapper">
        <div v-for="contact in contacts.filter((x) => x.contactType === 'Support')" style="width: fit-content;">
          <PartnerContact :contact="contact" :toggleActionModal="toggleActionModal" />
        </div>
      </div>
    </div> -->
    <ContactModal
      :show="showModal"
      :view="modalView"
      :toggle="toggleActionModal"
      :contact="contact"
      :currentCorporation="currentCorporation"
      :update="update"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';
import providerPlanMixin from '@shared/mixins/providerPlanMixin';
import PartnerContact from './PartnerContact.vue';
import ContactModal from '../../partnerSettings/contactModal/ContactModal.vue';

export default {
  name: 'ContactsSection',
  components: {
    PartnerContact,
    ContactModal,
  },
  mixins: [partnerSettingsMixin, providerPlanMixin],
  props: {
    partnerSettings: Object,
    currentCorporation: Object,
    update: Function,
    change: Function,
  },
  data() {
    return {
      contact: {},
      type: '',
      loadingPlans: false,
      showModal: false,
      modalView: '',
    };
  },
  async mounted() {
    this.loadingPlans = true;
    await this.$store.dispatch('getPartnerContacts', {
      corpId: this.currentCorporation.id,
    });
    this.loadingPlans = false;
  },
  methods: {
    toggleActionModal(show, view, contact) {
      this.showModal = show;
      if (show) {
        this.modalView = view;
        this.contact = contact;
      } else {
        this.contact = {};
        this.type = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 20px;
  font-weight: 700;
}
.cards-wrapper {
  flex-wrap: wrap;
  display: flex;
}
.sub-header {
  font-size: 16px;
  font-weight: 500;
  color: $N60;
}

.icn-btn {
  color: $NBLUE110;
  border-radius: 4px;
  padding: 10px 16px;
  border: 2px solid $NBLUE110;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
}

.s-setting-container {
  display: flex !important;
  flex-direction: column;
}

.contacts-container {
  border-radius: 4px;
  border: 1px solid #C4C5CC;
  padding: 15px 20px;
}
</style>
